'use client'

import { store } from './store'
import { Provider } from 'react-redux'

// Redux-only provider (no SessionProvider)
// Use this for non-authenticated pages to avoid session polling
export const ReduxProvider = ({ children }: { children: React.ReactNode }) => {
    return <Provider store={store}>{children}</Provider>
}
